import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { appInitialActions } from 'src/app/core/root-store/root.actions';
import { environment } from 'src/environments/environment';
import { selectAppConnectionStatus } from 'src/app/core/root-store/root.selectors';
import { AppStateInterface } from 'src/app/core/root-store/root.state';
import { NgxLoader } from 'ngx-http-loader';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { UsageOverviewService } from "src/app/shared/metrics-shared/services/usage-overview.service";
import { AuthService } from "src/app/chatperk-core/services/auth.service";
import { EAccessType } from './chatperk-core/enums';
import { SubscriptionService } from './shared/subscription-shared/services/subscription.service';
import { GoogleTagManagerService } from "angular-google-tag-manager";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'The Coolest App On Earth';
  loader = NgxLoader;

  loadingRoute = false;

  constructor(
    private store: Store<AppStateInterface>,
    private router: Router,
    private authService: AuthService,
    private usageOverviewService: UsageOverviewService,
    private subscriptionService: SubscriptionService,
    private gtmService: GoogleTagManagerService,
  ) {
  }

  ngOnInit() {
    this.store.dispatch(
      appInitialActions.appStarted({ version: environment.version }),
    );
    this.store.select(selectAppConnectionStatus).subscribe((state) => {
      if (state > 0) {
        console.log('%c✅ Online', 'color:green;font-size: 18px');
      } else if (state === 0) {
        console.log('%c🚫 Offline', 'color:red;font-size: 18px');
      } else {
        console.log('Testing connection...');
      }
    });
    this.checkRouteState();
    if (this.authService.getUser() &&  this.authService.getUser()?.activeSpace && (this.authService.getCurrentTokenType()?? "") == EAccessType.FAT) {
      this.usageOverviewService.loadUsageOverview().subscribe();
      this.subscriptionService.loadActiveSubscription().subscribe();
    }
    this.gtmService.addGtmToDom();
  }

  private checkRouteState() {
    this.router.events.subscribe({
      next: (event) => {
        if (event instanceof NavigationStart) {
          this.loadingRoute = true;
        }
        if (event instanceof NavigationEnd) {
          this.loadingRoute = false;
        }

        // Set loadingRoute state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
          this.loadingRoute = false;
        }
        if (event instanceof NavigationError) {
          this.loadingRoute = false;
        }
      },
    });
  }
}
